import { getOperationsCsrf, operationsLogin, operationsLogout } from "../operations/operationsApi";

const BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

export { operationsLogin, operationsLogout };

export async function getAdminOverview(restaurantId) {
  const response = await fetch(`${BASE}/api/operations/${restaurantId}/admin/overview/`, {
    credentials: "include",
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.detail || data.error || `Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return data;
}

export { getOperationsCsrf };


export async function getRestaurantProfile(restaurantId) {
  const response = await fetch(`${BASE}/api/operations/${restaurantId}/admin/profile/`, { credentials: "include" });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) { const error = new Error(data.detail || data.error || `Request failed (${response.status})`); error.status = response.status; throw error; }
  return data;
}

export async function updateRestaurantProfile(restaurantId, values, logoFile) {
  const csrf = await getOperationsCsrf();
  const body = new FormData();
  for (const key of ["name", "phone", "email", "address"]) body.append(key, values[key] || "");
  if (logoFile) body.append("logo", logoFile);
  const response = await fetch(`${BASE}/api/operations/${restaurantId}/admin/profile/`, {
    method: "PATCH", credentials: "include", headers: { "X-CSRFToken": csrf.csrfToken }, body,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const details = Object.entries(data).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(", ") : value}`).join("; ");
    const error = new Error(details || `Request failed (${response.status})`); error.status = response.status; throw error;
  }
  return data;
}

export async function getAdminAnalytics(restaurantId, days = 7) {
  const response = await fetch(`${BASE}/api/operations/${restaurantId}/admin/analytics/?days=${days}`, {
    credentials: "include",
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.detail || data.error || `Analytics request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return data;
}

export async function getAdminReports(restaurantId, startDate, endDate) {
     const params = new URLSearchParams({start_date: startDate, end_date: endDate});
     const response = await fetch(`${BASE}/api/operations/${restaurantId}/admin/reports/?${params}`, {credentials: 'include'});
     const data = await response.json().catch(() => ({}));
     if (!response.ok) { const error = new Error(data.detail || data.error || `Report failed (${response.status})`); error.status = response.status; throw error; }
     return data;
   }

export async function getAdminSettings(restaurantId) {
  const response = await fetch(`${BASE}/api/operations/${restaurantId}/admin/settings/`, { credentials: 'include' });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.detail || data.error || `Settings request failed (${response.status})`);
  return data;
}

export async function updateAdminSettings(restaurantId, values) {
  const csrf = await getOperationsCsrf();
  const response = await fetch(`${BASE}/api/operations/${restaurantId}/admin/settings/`, {
    method: 'PATCH', credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrf.csrfToken },
    body: JSON.stringify(values),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.detail || data.error || `Settings update failed (${response.status})`);
  return data;
}

export async function changeOwnPassword(restaurantId, currentPassword, newPassword) {
  const csrf = await getOperationsCsrf();
  const response = await fetch(`${BASE}/api/operations/${restaurantId}/admin/change-password/`, {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrf.csrfToken },
    body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = Object.values(data).flat().join(' ') || `Request failed (${response.status})`;
    throw new Error(detail);
  }
  return data;
}